import { useChatStore } from '@avila-roffe/settings';
import { MessageSquare } from 'lucide-react';
import { useLocation } from 'react-router';

interface ChatFabProps {
  hidePaths?: string[];
}

export function ChatFab({ hidePaths = ['/chat'] }: ChatFabProps) {
  const panelOpen = useChatStore((s) => s.panelOpen);
  const togglePanel = useChatStore((s) => s.togglePanel);
  const location = useLocation();

  if (hidePaths.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`)))
    return null;

  return (
    <button
      type="button"
      onClick={togglePanel}
      aria-label={panelOpen ? 'Close chat' : 'Open chat'}
      style={{ bottom: 'calc(1.5rem + env(safe-area-inset-bottom))' }}
      className={[
        'fixed right-6 z-50',
        'flex size-14 items-center justify-center rounded-full',
        'bg-primary/75 text-primary-foreground shadow-xl backdrop-blur-sm',
        'transition-all duration-300 hover:bg-primary/90',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        panelOpen ? 'opacity-0 pointer-events-none scale-75' : 'opacity-100 scale-100',
      ].join(' ')}
    >
      <MessageSquare className="size-6" aria-hidden="true" />
    </button>
  );
}
